import { IConciliator } from "@/@core/modules/conciliator/domain/conciliator.entity";
import { ColumnsType } from "antd/es/table";
import React from 'react';
import { Button, Tooltip } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

export const columns = (navigate: any, onShowHistory?: (record: IConciliator) => void): ColumnsType<IConciliator> => {
    let previousVindiKey: number | null = null;
    let previousAppliedFee: number | bigint | null = null;

    return [
        {
            title: 'Histórico',
            key: 'history',
            width: 100,
            align: 'center',
            render: (_, record: IConciliator) => (
                onShowHistory ? (
                    <Tooltip title="Ver histórico">
                        <Button
                            type="text"
                            icon={<EyeOutlined />}
                            onClick={() => onShowHistory(record)}
                            style={{ 
                                color: record.history && record.history.length > 0 ? '#1890ff' : '#d9d9d9' 
                            }}
                        />
                    </Tooltip>
                ) : null
            ),
            responsive: ['sm'],
        },
        {
            title: 'ID Conciliação',
            dataIndex: 'idConciliation',
            sortDirections: ['descend'],
            fixed: 'left',
            responsive: ['sm'],
        },
        {
            title: 'ID da Agenda',
            dataIndex: 'schedules',
            render: (value: number) => {
                if (value) {
                    return <a onClick={() => navigate(`/schedule/${value}`)}>{value}</a>
                } else {
                    return 'ID Não Encontrado';
                }
            },
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'Nro. Primário NF',
            dataIndex: 'primaryOrderNumber',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'Nro. SAP',
            dataIndex: 'primaryInvoiceNumber',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'A receber',
            dataIndex: 'primaryIncomePayment',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'Taxa',
            dataIndex: 'tax',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'Data Aprovação',
            dataIndex: 'approvalDate',
            render: (value: string) => {
                const date = value.split(" ")[0];
                return date;
            },
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'Valor Transação',
            dataIndex: 'transactionValue',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
            render: (value: number | bigint) => new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(value),
        },
        {
            title: 'Taxa aplicada',
            dataIndex: 'appliedFee',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
            render: (value: number | bigint, record: IConciliator) => {
                if (value === 0)
                    return ''
                if (record.vindiKey === previousVindiKey && value === previousAppliedFee) {
                    return '';
                }
                previousVindiKey = record.vindiKey;
                previousAppliedFee = value;
                return new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                }).format(value);
            },
        },
        {
            title: 'Valor Líquido',
            dataIndex: 'liquidValue',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
            render: (value: number | bigint) => new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(value),
        },
        {
            title: 'Nro. Parc.',
            dataIndex: 'installmentNumber',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'Chave VINDI',
            dataIndex: 'vindiKey',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'Tipo Pgto',
            dataIndex: 'paymentType',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'Status',
            dataIndex: 'status',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        },
        {
            title: 'Obs.',
            dataIndex: 'observation',
            defaultSortOrder: 'descend',
            responsive: ['sm'],
        }
    ];
};
